import React, { useEffect, useState } from "react";
import CommonMuiTable, { Table } from "../../Component/Table/Table";
import { delete_icon, View_icon } from "../../assets/img";
import { URLS } from "../../Services/Constant";
import { deletes, get, post } from "../../Services/ApiHandler";

import { Toast } from "../../Component/Toast";
import Loader from "../../Component/Loader";
import useStoreKv from "../redux/store/useStorekv";
import CustomScroll from "../../Component/CustomScroll";

const Announcement = () => {

  const { kv, set } = useStoreKv();
  const announcementList = kv.announcementlist || [];
  const announcement = kv.announcement || [];

  const [page, setPage] = useState(1);
  const [idd, setIdd] = useState();
  const [pagination, setPagination] = useState("");
  const [popup, setPopup] = useState(false);
  const [popup1, setPopup1] = useState(false);
  const [Announce, setAnnounce] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [loading3, setLoading3] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showMessage, setShowMessage] = useState('');
  const [title, setTitle] = useState('');
  const [formData, setFormData] = useState(announcement ?? {
    Announcement: '',
    title: '',
    message: ''
  });

  const [owners, setOwners] = useState(announcementList);

  const getList = async () => {
    try {
      // setLoading(true);
      const res = await get(`${URLS.MASTER}?type=3`);
//       console.log("Fetched data:", res);

      const resNotifyList = await get(`${URLS.NOTIFICATION}`);

      if (res?.status === "success" && res?.data) {
        setFormData({
          Announcement: res?.data?.message
        })
        set(`announcement`, { Announcement: res?.data?.message });
      } else {
        Toast(res?.message || "No data found");
        set(`announcement`, { Announcement: '' });
      }

      if (resNotifyList?.status === "success") {
        setOwners(resNotifyList?.data);
        set(`announcementlist`, resNotifyList?.data);
      } else {
        setOwners([]);
        set(`announcementlist`, []);
      }

    } catch (err) {
      Toast("Failed to load links");
      console.error(err);
    } finally {
      // setLoading(false);
    }
  };

  useEffect(() => {
    getList();
  }, []);


  const handleUpdateAnnounce = async () => {
    try {
      setLoading2(true);
      const payload = {
        id: 3,
        message: formData?.Announcement
      };
      const res = await post(`${URLS.ANNOUNCEUPDATE}`, payload);
//       console.log("Update response:", res);

      if (res?.status === "success") {
        Toast(res?.message || "updated successfully!");
        setPopup1(false);
      } else {
        Toast(res?.message || "Update failed!");
        setPopup1(false);
      }
    } catch (err) {
      Toast("Error updating");
      console.error(err);
    } finally {
      setLoading2(false);
      setPopup1(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleAnnounce = async () => {
    try {
      setLoading3(true);
      const payload = {
        title: formData?.title,
        message: formData?.message
      };
      const res = await post(`${URLS.NOTIFICATION}/store`, payload);
//       console.log("Update response:", res);

      if (res?.status === "success") {
        Toast(res?.message || "updated successfully!");
        setFormData({
          message: '',
          title: ""
        })
        getList();
      } else {
        Toast(res?.message || "Update failed!");
      }
    } catch (err) {
      Toast("Error updating");
      console.error(err);
    } finally {
      setLoading3(false);
    }
  }

  const handleDelete = async () => {
    setIsLoading(true);
    const res = await deletes(`${URLS.NOTIFICATION}/${idd}`);
//     console.log("res meesage delete", res);
    if (res.status === "success") {
      setPopup(false);
      getList();
      setIsLoading(false);
    } else { setIsLoading(false); }
  }


  const columns = React.useMemo(
    () => [
      {
        Header: " Date",
        accessor: "date",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "Time",
        accessor: "created_at",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "Notification",
        accessor: "message",
        Cell: ({ value }) => {
          const truncated =
            value && value.length > 15 ? value.substring(0, 15) + "..." : value;

          return (
            <p style={{ whiteSpace: "nowrap", width: "120px" }}>
              {truncated}
            </p>
          );
        },
      },
      {
        Header: "Admin",
        accessor: "",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap">{row?.original?.created_by?.name}</p>;
        },
      },

      {
        Header: "Action",
        accessor: "",
        Cell: ({ value, row }) => {
          return (
            <React.Fragment>
              <div className="d-flex ac-jc gap-3">
                <button onClick={() => {
                  setAnnounce(true);
                  setTitle(row?.original?.title)
                  setShowMessage(row?.original?.message);
                }} className="cust-btn ">
                  <img
                    src={View_icon}
                    height={15}
                    alt=""
                    className="view-btn "
                  />
                </button>

                <button onClick={() => {
                  setPopup(true);
                  setIdd(row?.original?.id)
                }} className="cust-btn ">
                  <img src={delete_icon} alt="" className=" delete-icon " />
                </button>
              </div>
            </React.Fragment>
          );
        },
      },
    ],
    []
  );

  return (
    <div className="dashRightView d-flex ac-jb flex-column">
      <CustomScroll height="100vh">
        <div style={{ paddingTop: 0 }} className="container_overalls">
          <div className="d-flex ac-js col-md-5 my-1">
            <label style={{ margin: 0 }} className="form-label f3 fs-xs-18 fs-sm-18 fs-md-18 fs-lg-19 fs-xl-21 fs-xxl-22  primary">
              Announcement
            </label>
          </div>
          <div className="col-md-5 my-3 announcement_box">
            <h4 className="f3  fs-xs-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 announcement_title">
              Message
            </h4>
            <textarea
              className="form-control5  fs-xs-15 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 placholdercolorchanges2"
              placeholder="Type here..."
              name="Announcement"
              value={formData?.Announcement}
              rows="4"
              onChange={handleChange}
            ></textarea>
          </div>
          <div className="col-md-5 my-3">
            <button disabled={loading2} onClick={() => setPopup1(true)} className="add-button f3 w-100 fs-xs-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 white">
              Update
            </button>
          </div>
          <div style={{ marginTop: 20 }} className="d-flex ac-js col-md-5 ">
            <label style={{ margin: 0 }} className="form-label f3 fs-xs-18 fs-sm-18 fs-md-18 fs-lg-19 fs-xl-21 fs-xxl-22  primary">
              Push Notification
            </label>
          </div>
          <label className="form-label mt-2 f2 fs-md-14 fs-lg-16 m-0 primary1">
            Title</label>
          <div className="col-md-5 my-1 announcement_box">
            <textarea
              className="form-control5 f2 fs-xs-15 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 placholdercolorchanges2"
              placeholder="Type here..."
              rows="2"
              name="title"
              value={formData?.title}
              onChange={handleChange}
            ></textarea>
          </div>
          <label className="form-label mt-2 f2 fs-md-14 fs-lg-16 m-0 primary1">
            Message</label>
          <div className="col-md-5 my-1 announcement_box">
            <textarea
              className="form-control5 f2 fs-xs-15 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 placholdercolorchanges2"
              placeholder="Type here..."
              rows="4"
              name="message"
              value={formData?.message}
              onChange={handleChange}
            ></textarea>
          </div>
          <div className="col-md-5 my-3">
            <button
              disabled={!formData?.title && !formData?.message}
              onClick={handleAnnounce}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "8px",
                minHeight: 48,
                backgroundColor: (!formData?.title || !formData?.message) ? '#9BBFBC' : '#004743',
                border: (!formData?.title || !formData?.message) ? "1px solid #9BBFBC" : "1px solid #004743",
              }}
              className="add-button f3 w-100 fs-xs-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 white">

              {loading3 ? <>
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                  style={{ color: "white" }}
                ></span>
              </> : 'Announce Notification'}
            </button>
          </div>
          <div className="d-flex ac-js col-md-5 my-3">
            <label className="form-label f3 fs-xs-18 fs-sm-18 fs-md-18 fs-lg-19 fs-xl-21 fs-xxl-22  primary">
              Notification List
            </label>
          </div>

          <Table
            columns={columns}
            setPageno={setPage}
            pagecount={pagination}
            data={owners}
            show={false}
          />
        </div>
        {loading && <Loader />}
        {popup && (
          <div className="img-popup-design">
            <div className="img-popup">
              <p className="f3 fs-xs-14 fs-sm-15 fs-md-15 fs-lg-15 fs-xl-17 fs-xxl-19 primary">
                Are you sure you want to Delete?
              </p>
              <div style={{ paddingTop: 20 }} className="d-flex ac-jb px-2 f3 fs-xs-14 fs-sm-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19">
                <button onClick={() => setPopup(false)} className="no-btn w-40">
                  No
                </button>
                <button
                  onClick={handleDelete}
                  className="yes-btn f2 w-40 f3 fs-xs-14 fs-sm-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19"
                >
                  {isLoading ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                        style={{ color: "white", padding: 8 }}
                      ></span>
                    </>
                  ) : (
                    <span style={{ top: -1.5, position: 'relative' }}>Yes</span>
                  )}

                </button>
              </div>
            </div>
          </div>
        )}
        {Announce && (
          <div onClick={() => setAnnounce(false)} className="img-popup-design3">
            <div className="img-popup3">
              <button className="close-btn " onClick={() => setAnnounce(false)}>
                ×
              </button>
              <h4 className="f3  fs-xs-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 announement_title2">
                Message
              </h4>

              <div
                className="messageShow"
              >
                <h1 className="f3 fs-xs-16" style={{ borderBottom: "2px solid #000", paddingBottom: "4px", width: 'fit-content' }}>
                  {title}
                </h1>

                <p className="f2 fs-xs-16">{showMessage}</p>
              </div>
            </div>
          </div>
        )}
        {popup1 && (
          <div className="img-popup-design">
            <div className="img-popup">
              <p className="f3 fs-xs-14 fs-sm-15 fs-md-15 fs-lg-15 fs-xl-17 fs-xxl-19 primary">
                Are you sure you want to Update?
              </p>
              <div style={{ paddingTop: 20 }} className="d-flex ac-jb px-2 f3 fs-xs-14 fs-sm-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19">
                <button onClick={() => setPopup1(false)} className="no-btn w-40">
                  No
                </button>
                <button
                  onClick={handleUpdateAnnounce}
                  className="yes-btn f2 w-40 f3 fs-xs-14 fs-sm-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19"
                >
                  {loading2 ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                        style={{ color: "white", padding: 8 }}
                      ></span>
                    </>
                  ) : (
                    <span style={{ top: -1.5, position: 'relative' }}>Yes</span>
                  )}

                </button>
              </div>
            </div>
          </div>
        )}
      </CustomScroll>
    </div>
  );
};

export default Announcement;
